import { EventEmitter as Emitter } from 'eventemitter3';


export const eventEmitter = new Emitter();

export const EventEmitter = {
  on: (event, callback) => eventEmitter.on(event, callback),
  once: (event, callback) => eventEmitter.once(event, callback),
  off: (event, callback) => eventEmitter.off(event, callback),
  emit: (event, payload) => eventEmitter.emit(event, payload),
};
